import {
  IAwards,
  IHero,
  IInvestors,
  ILeadership,
  INews,
  IPartnerships,
  IPlayYourPart,
  IWalkthrough,
} from '@interfaces/aboutUs'

export const AwardsMock: IAwards = {
  title: 'Awards and achievements',
  description: 'Brand in action',
  awards: [
    {
      src: 'https://acko-cms.ackoassets.com/Award_2022_4228a7b3e7.webp',
      alt: 'Left Award',
      position: 'left',
    },
    {
      src: 'https://acko-cms.ackoassets.com/Award_2024_d7d8d168f5.webp',
      alt: 'Center Award',
      position: 'center',
    },
    {
      src: 'https://acko-cms.ackoassets.com/Award_2023_7dc57fa940.webp',
      alt: 'Right Award',
      position: 'right',
    },
  ],
}

export const HeroMock: IHero = {
  heading: 'Building the insurance experience you always deserved',
  subHeading:
    'Our mission is to empower people with reliable protection for complete peace of mind and lasting prosperity',
  features: [
    {
      icon: 'https://acko-cms.ackoassets.com/Tech_7282c90a3d.svg',
      title: 'Technology driven',
      description: 'We use technology to make insurance simple and accessible.',
    },
    {
      icon: 'https://acko-cms.ackoassets.com/transperant_0d155c6a52.svg',
      title: 'Transparent pricing',
      description: 'No hidden costs, just clear and honest pricing.',
    },
    {
      icon: 'https://acko-cms.ackoassets.com/handshake_66d8c1339c.svg',
      title: 'Customer first',
      description: 'We put our customers at the heart of everything we do.',
    },
  ],
  backgroundVideoDesktopSrc: 'https://acko-cms.ackoassets.com/Desktop_Hero_final_324e259760.mp4',
  backgroundVideoMobileSrc: 'https://acko-cms.ackoassets.com/Mobile_Hero_SE_20da0c7862.mp4',
}

export const InvestorsMock: IInvestors = {
  title: 'Our Investors',
  description: 'Backed by the best in the business',
  bigCards: [
    {
      investorName: 'Shantanu Rastogi',
      investorTitle: 'Managing Director',
      investorContent:
        '“ACKO has developed a scalable and differentiated business model based on a singular customer focus, value-based pricing, highly-rated service and deep technology capabilities.',
      investorLogoUrl: 'https://acko-cms.ackoassets.com/general_atlantic_investor_2ad3283f1b.svg',
    },
    {
      investorName: 'Nithya Easwaran',
      investorTitle: 'Managing Director',
      investorContent:
        '“ACKO has helped to revolutionize general insurance through its D2C technology led model, product innovation and strong customer experience.',
      investorLogoUrl: 'https://acko-cms.ackoassets.com/Multiples_bd83c2f829.svg',
    },
  ],
  cards: [
    {
      investorLogoUrl: 'https://acko-cms.ackoassets.com/CPPI_4f5d76b8b4.svg',
    },
    {
      investorLogoUrl: 'https://acko-cms.ackoassets.com/accel_385aa17514.svg',
    },
    {
      investorLogoUrl: 'https://acko-cms.ackoassets.com/Elevation_Capital_c94a2060b8.svg',
    },
    {
      investorLogoUrl: 'https://acko-cms.ackoassets.com/lightspeed_1_84ed453670.svg',
    },
    {
      investorLogoUrl: 'https://acko-cms.ackoassets.com/Ventureast_Logo_1_8df3c0bc1d.svg',
    },
    {
      investorLogoUrl: 'https://acko-cms.ackoassets.com/Ascent_Capital_6a9837e1a4.svg',
    },
    {
      investorLogoUrl: 'https://acko-cms.ackoassets.com/intact_1_f9478f9a78.svg',
    },
  ],
}

export const LeadershipMock: ILeadership = {
  title: 'Our leadership',
  description: 'Redefining insurance, one decision at a time',
  founderData: [
    {
      founderName: 'Varun Dua',
      founderTitle: 'Founder',
      founderImageUrl: 'https://acko-cms.ackoassets.com/Varun_Dua_e01ecd7a84.webp',
    },
    {
      founderName: 'Vishwanath Ramarao',
      founderTitle: 'Co-Founder',
      founderImageUrl: 'https://acko-cms.ackoassets.com/Vishwanath_Ramarao_ed5c7a6a6d.webp',
    },
    {
      founderName: 'Ruchi Deepak',
      founderTitle: 'Founder Emeritus',
      founderImageUrl: 'https://acko-cms.ackoassets.com/Ruchi_Deepak_4f0dd84deb.webp',
    },
    {
      founderName: 'Nitin Sood',
      founderTitle: 'Chief Financial Officer',
      founderImageUrl: 'https://acko-cms.ackoassets.com/Nitin_Sood_bef80397ef.webp',
    },
    {
      founderName: 'Ashish Mishra',
      founderTitle: 'Executive VP - Marketing',
      founderImageUrl: 'https://acko-cms.ackoassets.com/Ashish_Mishra_e490373e0f.webp',
    },
    {
      founderName: 'Sharayu Jadhav',
      founderTitle: 'Senior VP - Legal and Compliance',
      founderImageUrl: 'https://acko-cms.ackoassets.com/Sharayu_Jadhav_d1c351cb0e.webp',
    },
  ],
}

export const NewsMock: INews = {
  title: 'Our Stories',
  description: 'ACKO in the news',
  newsData: [
    {
      newsLogoUrl: 'https://acko-cms.ackoassets.com/inc42_news_bed39c0a80.svg',
      newsDate: '16 Jan, 2025',
      newsHeading: 'ACKO’s revenue jumps 20% to cross ₹2,000 Cr mark In FY24',
      newsContent:
        'Bengaluru-based insurtech unicorn ACKO Datalabs in-article-icon managed to trim its consolidated net loss...',
      newsImageUrl: 'https://acko-cms.ackoassets.com/inc42_cover_news_316ca2192d.webp',
      newsUrl: 'https://inc42.com/buzz/ackos-revenue-jumps-20-to-cross-inr-2000-cr-mark-in-fy24/',
    },
    {
      newsLogoUrl: 'https://acko-cms.ackoassets.com/24m_news_73588805b4.webp',
      newsDate: '16 Jan, 2025',
      newsHeading: 'ACKO rebrands with a logo inspired by the Möbius strip',
      newsContent:
        'ACKO has rebranded as part of its ongoing efforts to innovate and address customer needs. The new identity reflects the company’s...',
      newsImageUrl: 'https://acko-cms.ackoassets.com/24m_cover_news_35c3bd77eb.webp',
      newsUrl: 'https://www.exchange4media.com/marketing-news/acko-rebrands-itself-with-new-logo-140466.html',
    },
    {
      newsLogoUrl: 'https://acko-cms.ackoassets.com/financial_express_news_69e217bc3c.svg',
      newsDate: '11 Nov, 2024',
      newsHeading: 'CRED adds ACKO as insurance partner on Cred Garage',
      newsContent:
        'CRED has partnered with Acko Insurance to expand the offerings on its vehicle management platform, CRED Garage...',
      newsImageUrl: 'https://acko-cms.ackoassets.com/financial_express_cover_news_25e89dad20.webp',
      newsUrl: 'https://www.financialexpress.com/money/cred-adds-acko-as-insurance-partner-on-cred-garage-3661955/',
    },
  ],
}

export const PartnershipMock: IPartnerships = {
  partnerships: [
    { id: 'one', value: 1, content: { capital: 'Brand in action', heading: 'Power-packed partnerships' } },
    { id: 'two', value: 2, image: 'https://acko-cms.ackoassets.com/shark_tank_india_766555a3da.svg', fullImage: false },
    { id: 'three', value: 3, image: 'https://acko-cms.ackoassets.com/Player_03d8d1629b.mp4', fullImage: true },
    { id: 'four', value: 4, image: 'https://acko-cms.ackoassets.com/Delhi_capitals_0ebf38a881.svg', fullImage: false },
    { id: 'five', value: 5, image: 'https://acko-cms.ackoassets.com/gujarat_titans_616144566b.svg', fullImage: false },
    { id: 'six', value: 6, image: 'https://acko-cms.ackoassets.com/KKR_2f18298485.svg', fullImage: false },
    {
      id: 'seven',
      value: 7,
      image: 'https://acko-cms.ackoassets.com/shark_tank_investors_33ad2c66d7.webp',
      fullImage: true,
    },
    { id: 'eight', value: 8, image: 'https://acko-cms.ackoassets.com/KBC_ebceeb71c7.webp', fullImage: false },
  ],
}

export const PlayYourPartMock: IPlayYourPart = {
  title: 'Want to play your part at ACKO?',
  description: 'Build products that put people before paperwork',
  buttonLink: '/careers/',
  buttonText: 'Join Us',
  bannerImageSrc: 'https://acko-cms.ackoassets.com/Acko_Building_e475a7797e.webp',
}

export const WalkthroughMock: IWalkthrough = {
  title: 'Our journey',
  description: 'A Walkthrough of our wins',
  journeyData: [
    {
      year: '2016',
      text: 'ACKO was born',
      image: 'https://acko-cms.ackoassets.com/2016_ce40903efc.webp',
      image2: 'https://acko-cms.ackoassets.com/2016_tab_ed45fe2c95.webp',
    },
    {
      year: '2018',
      text: 'Launched car insurance',
      image: 'https://acko-cms.ackoassets.com/2018_ec75035a7c.webp',
      image2: 'https://acko-cms.ackoassets.com/2018_tab_9944b690c1.webp',
    },
    {
      year: '2020',
      text: 'Expanded into corporate health insurance',
      image: 'https://acko-cms.ackoassets.com/2020_8530f57d74.webp',
      image2: 'https://acko-cms.ackoassets.com/2020_tab_a34da1b2d9.webp',
    },
    {
      year: '2021',
      text: 'Crossed the billion-dollar mark. Became a unicorn',
      image: 'https://acko-cms.ackoassets.com/2021_197c203598.webp',
      image2: 'https://acko-cms.ackoassets.com/2021_tab_f4a532feb7.webp',
    },
    {
      year: '2022',
      text: 'Marked ₹1,000 crore in annual revenue',
      image: 'https://acko-cms.ackoassets.com/2022_772ec02bbd.webp',
      image2: 'https://acko-cms.ackoassets.com/2022_tab_d86b09f57b.webp',
    },
    {
      year: '2023',
      text: 'Stepped into health and travel insurance',
      image: 'https://acko-cms.ackoassets.com/2023_e24dc69220.webp',
      image2: 'https://acko-cms.ackoassets.com/2023_tab_60a79a8a26.webp',
    },
    {
      year: '2024',
      text: 'Began a new chapter with life insurance',
      image: 'https://acko-cms.ackoassets.com/2024_tab_03070c40b2.webp',
      image2: 'https://acko-cms.ackoassets.com/2024_344c74d107.webp',
    },
    {
      year: '2025',
      text: "Shaping India's protection destination",
      image: 'https://acko-cms.ackoassets.com/2025_834740187e.webp',
      image2: 'https://acko-cms.ackoassets.com/2025_tab_37ec31cc31.webp',
    },
  ],
}

export const VideoCompMock = {
  videoSrc: 'https://acko-cms.ackoassets.com/About_US_Varun_Video_cac6bdfba8.mp4',
  fullText:
    '“Where others saw tradition, I saw friction—paperwork, middlemen, and endless fine print. That’s when I knew insurance didn’t just need a change, it needed a revolution.”',
  subText: 'Varun Dua - the mind behind the mission',
}
